<mat-tree [dataSource]="dataSource"
            [treeControl]="treeControl"
            class="tree"
  >

    <mat-tree-node *matTreeNodeDef="let node"
                   matTreeNodeToggle
                   [showIfPermission]="node.permissions"
    >
      <li class="mat-tree-node">

        <a class="estricta uppercase bolder menu-item"
           *ngIf="!node.path.startsWith('http') else externalLinkVertical"
           [attr.data-cy]="returnDataCy(eixo, node.name)"
           (click)="handleNodeClick(node)"
           > {{node.name}} </a>

        <ng-template #externalLinkVertical>
          <a class="estricta uppercase bolder"
             [attr.data-cy]="returnDataCy(eixo, node.name)"
             (click)="handleNodeClick(node)"> {{node.name}} </a>
        </ng-template>
      </li>
    </mat-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">

      <li matTreeNodeToggle
          class="mat-nested-tree-item"
          [showIfPermission]="node.permissions"
          [attr.data-cy]="returnDataCy(eixo, node.name)">

        <div class="flex estricta uppercase bolder">
          <a>{{node.name}}</a>
          <mat-icon class="icon-display"> {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}} </mat-icon>
        </div>

        <ul [class]="eixo" [@slideVertical]="treeControl.isExpanded(node) ? 'show' : null">
          <ng-container matTreeNodeOutlet></ng-container>
        </ul>

      </li>
    </mat-nested-tree-node>

  </mat-tree>
